<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {SmartOfferKind} from "@/modules/redactor/models/smart-offer/core/SmartOfferKind";

export default {
  name: "r-smart-offer-kind",
  props: {
    model: VueTypes.instanceOf(SmartOfferKind),
    label: VueTypes.string.def("Group:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SmartOfferKind.getValues();
    }
  }
}
</script>
